import { subCompanyChannelsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SUB_COMPANY_CHANNELS_ACTION_TYPE = createNamedActions('subCompanyChannels', {
  GET_CHANNELS: 'GET_CHANNELS',
  ADD_CHANNEL: 'ADD_CHANNEL',
  REMOVE_CHANNEL: 'REMOVE_CHANNEL',
  RESET_STATE: 'RESET_STATE',
});

export const getSubCompanyChannelsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompanyChannelsApi.getSubCompanyChannels(params);

  return dispatch({
    type: SUB_COMPANY_CHANNELS_ACTION_TYPE.GET_CHANNELS,
    payload: data,
  });
});

export const addSubCompanyChannelAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompanyChannelsApi.addSubCompanyChannel(params);

  return dispatch({
    type: SUB_COMPANY_CHANNELS_ACTION_TYPE.ADD_CHANNEL,
    payload: data,
  });
});

export const removeSubCompanyChannelAction = catchAsyncActionError(params => async dispatch => {
  await subCompanyChannelsApi.removeSubCompanyChannel(params);

  return dispatch({
    type: SUB_COMPANY_CHANNELS_ACTION_TYPE.REMOVE_CHANNEL,
    meta: params,
  });
});
